import { memo } from "react";

const SvgComponent = ({ width = 8, height = 14, color = "#6B47F5" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.464215 7.81588L6.22278 13.5292C6.62689 13.9373 7.23306 13.9373 7.63717 13.5292C8.04128 13.1211 8.04128 12.509 7.63717 12.1009L2.68682 6.99969L7.63717 1.89847C8.04128 1.49038 8.04128 0.878232 7.63717 0.470135C7.43511 0.266086 7.23306 0.164062 6.92997 0.164062C6.62689 0.164062 6.42484 0.266086 6.22278 0.470135L0.464215 6.18349C0.0601054 6.69361 0.0601054 7.30576 0.464215 7.81588C0.464215 7.71386 0.464215 7.71386 0.464215 7.81588Z"
      fill={color}
    />
  </svg>
);

const ArrowIcon = memo(SvgComponent);

export default ArrowIcon;
